import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { FloatingContainer } from './floating-button.component.styled';

interface FloatingButtonProps {
  children: any
}

const FloatingButton: React.FC<Props> = ({children}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <FloatingContainer $isOpen={isOpen}>
      <div className="fab" onClick={() => setIsOpen(!isOpen)}>
        <div className="fab-content">
          <i className="fa-solid fa-question" />
        </div>
      </div>
      {isOpen && children}
    </FloatingContainer>
  );
};

const mapStateToProps = (state: AppState, owsProps: FloatingButtonProps) => ({
  children: owsProps.children
});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FloatingButton);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  FloatingButtonProps